module.exports = __webpack_public_path__ + "static/media/fac1.2e3137a0.jpg";